import { createSlice } from "@reduxjs/toolkit";

const serverMessagesSlice = createSlice({
  name: "serverMessages",
  initialState: null,
  reducers: {
    setServerMessage(state, action) {
      // return radi u RTK reducerima
      return action.payload ?? null;
    },
    clearServerMessage() {
      return null;
    }
  }
});

export const { clearServerMessage, setServerMessage } = serverMessagesSlice.actions;
export default serverMessagesSlice.reducer;
